<template>
  <DialogComponent
    :cancelAction="cancelAction"
    :okAction="okAction"
    :showAction="showAction"
    :headerName="!isEdit ? `Create ${assetType.toLowerCase()}` : `Replace ${assetType.toLowerCase()}`"
    :okActionName="!isEdit ? `Create ${assetType.toLowerCase()}` : `Replace ${assetType.toLowerCase()}`"
    actionName="Add">
    <div slot="dialog-body" class="dialog-content" v-if="isShow">
      <div v-if="!isEdit">
        <TextComponent fieldName="ID" v-model="asset.fileId" />
      </div>
      <div v-if="isEdit && (products.length > 0)">
        <div class="replace-text">{{ asset.path }} is being used by the following products:</div>
        <ul class="product-list">
          <li v-for="(item, index) in products" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div v-else-if="isEdit">
        <div class="replace-text">{{ asset.path }} already exist.</div>
        <div class="replace-text">Are you sure you want to replace it, the existing
            {{ assetType.toLowerCase() }} will be replaced.</div>
      </div>
      <div class="file-upload">
        <FileUploadComponent
          :value="asset.path"
          fieldName="File"
          @changeValue="setValues"
          :acceptType="fileType" />
      </div>
    </div>
  </DialogComponent>
</template>

<script>
import DialogComponent from '../base.component/DialogComponent.vue';
import TextComponent from '../base.component/TextComponent.vue';
import FileUploadComponent from '../base.component/FileUploadComponent.vue';
import DropdownComponent from '../base.component/DropdownComponent.vue';
import { ASSET_TYPES, FILE_TYPES, ASSET_TYPES_BE } from '../../constants/assets.js';
import AssetsApiService from '../../services/assetsServices/assetsApiService';

export default {
  components: {
    DialogComponent,
    TextComponent,
    FileUploadComponent,
    DropdownComponent,
  },

  data() {
    return {
      asset: {
        id: '',
        fileId: '',
        type: '',
        path: '',
      },
      fileType: '',
      file: null,
      assetModel: {},
      regExValue: '',
      isShow: false,
      isEdit: false,
      products: []
    };
  },

  props: {
    assetType: String,
    required: true
  },

  watch: {
    asset: function () {
      this.setFileType();
    },
  },

  methods: {
    async okAction() {
      this.asset.type = this.assetType === ASSET_TYPES.MODEL ? ASSET_TYPES_BE.MODEL : this.assetType;
      this.asset.path = this.asset.fileId + this.fileType;
      const assetCreateModel = {
        asset: this.asset,
        file: this.file,
      };

      if (!this.isEdit) {
        this.$store.commit('isSpinnerLoading', true);
        await AssetsApiService.createAsset(assetCreateModel);
        this.$emit('updateTable', this.asset.type);
        this.$store.commit('isSpinnerLoading', false);
      } else {
        this.$emit('changeValue', assetCreateModel);
      }

      this.isShow = !this.isShow;
      this.isEdit = false;
    },

    cancelAction() {
      this.isShow = !this.isShow;
      this.isEdit = false;
    },

    showAction() {
      this.isShow = !this.isShow;

      if (!this.isEdit) {
        this.clearAsset();
      }
    },

    getAssetTypes() {
      return Object.values(ASSET_TYPES);
    },

    setValues(name, file) {
      if (file) {
        const fr = new FileReader();
        fr.readAsArrayBuffer(file);
        fr.onload = () => (this.file = fr.result);
        fr.onerror = () => console.error(fr.error);
      }

      if (!this.isEdit) {
        this.asset.fileId = name.replace(this.regExValue, '');
        this.asset.path = name;
      }
    },

    setAssetType(value) {
      this.asset.assetType = value.trim();
      this.asset.type = value.trim();
      this.setFileType();
    },

    setFileType() {
      switch (this.assetType) {
        case ASSET_TYPES.MODEL: {
          this.regExValue = new RegExp(FILE_TYPES.GLB, 'g');
          this.fileType = FILE_TYPES.GLB;
          break;
        }

        case ASSET_TYPES.IMAGE:
        case ASSET_TYPES.SLIDES: {
          this.regExValue = new RegExp(FILE_TYPES.JPG, 'g');
          this.fileType = FILE_TYPES.JPG;
          break;
        }

        case ASSET_TYPES.DATASHEET: {
          this.regExValue = new RegExp(FILE_TYPES.PDF, 'g');
          this.fileType = FILE_TYPES.PDF;
          break;
        }

        case ASSET_TYPES.ORTHO:
        case ASSET_TYPES.COLORCODE: {
          this.regExValue = new RegExp(FILE_TYPES.PNG, 'g');
          this.fileType = FILE_TYPES.PNG;
          break;
        }

        case ASSET_TYPES.VIDEO: {
          this.regExValue = new RegExp(FILE_TYPES.MP4, 'g');
          this.fileType = FILE_TYPES.MP4;
          break;
        }

        default: {
          this.regExValue = new RegExp(FILE_TYPES.JPG, 'g');
          this.fileType = FILE_TYPES.JPG;
          break;
        }
      }
    },

    clearAsset() {
      this.asset = {
        id: '',
        fileId: '',
        type: '',
        path: '',
      };
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-content {
  width: 50vh;
}

.dropdown-content {
  padding: 0;
  padding-right: 3.5px;
  margin-left: -3px;
  padding-top: 0.5rem;
}

.file-upload {
  margin-right: 8px !important;
}

.product-list {
  padding: 1rem;
  margin-top: 0.5rem;
  max-height: 10rem;
  overflow: scroll;
}

.replace-text {
  white-space: normal !important;
}
</style>